import * as RCheckbox from "@radix-ui/react-checkbox";
import type { ReactNode } from "react";

export interface CheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  /** Visible label text. Omit for label-less checkboxes (set
   *  `aria-label` instead for accessibility). */
  label?: ReactNode;
  disabled?: boolean;
  className?: string;
  name?: string;
  id?: string;
  /** Forwarded to the underlying Radix root for screen readers. */
  "aria-label"?: string;
  /** Forwarded so tests can target the checkbox directly. */
  "data-testid"?: string;
}

export function Checkbox({
  checked,
  onCheckedChange,
  label,
  disabled,
  className,
  name,
  id,
  "aria-label": ariaLabel,
  "data-testid": dataTestId,
}: CheckboxProps): JSX.Element {
  return (
    <label className={className ?? "ds-checkbox"}>
      <RCheckbox.Root
        className="ds-checkbox__root"
        checked={checked}
        onCheckedChange={(c) => onCheckedChange(c === true)}
        disabled={disabled}
        name={name}
        id={id}
        aria-label={ariaLabel}
        data-testid={dataTestId}
      >
        <RCheckbox.Indicator className="ds-checkbox__indicator">✓</RCheckbox.Indicator>
      </RCheckbox.Root>
      {label !== undefined && (
        <span className="ds-checkbox__label">{label}</span>
      )}
    </label>
  );
}
